/*
 * @Author: xgc
 * @Date: 2022-11-16 16:37:55
 * @LastEditors: xgc
 * @LastEditTime: 2023-01-31 13:33:07
 */
/**xgc
 * @description 导出默认主题配置
 */
const theme = {
  //是否国定头部 固定fixed 不固定noFixed
  header: 'fixed',
  //横纵布局 horizontal vertical
  layout: 'vertical',
  //是否开启主题配置按钮
  themeBar: false,
  //是否显示多标签页
  tabsBar: true,
}
module.exports = theme
